import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from 'styled-components';
import { fadeOut } from '../../../animations/keyframes';
import u from './utils';
var StyledToastWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    visibility: ", ";\n    animation: ", " 1s linear;\n    margin-top: ", "px;\n    transition: visibility 1s linear;\n\n    padding: 0 16px;\n    min-height: 50px;\n    width: fit-content;\n    margin-bottom: 16px;\n    box-sizing: border-box;\n    border-radius: 4px;\n\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n\n    border-width: 1px;\n    border-style: solid;\n    border-color: transparent;\n    background-color: ", ";\n\n    label {\n        margin: 0;\n        color: ", ";\n        padding-right: 24px;\n    }\n    i {\n        font-size: 24px;\n        color: ", ";\n        cursor: pointer;\n    }\n"])), function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? 'visible' : 'hidden';
}, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return !isVisible && fadeOut;
}, function (_ref3) {
  var customMarginTop = _ref3.customMarginTop;
  return customMarginTop || 0;
}, function (props) {
  return props.type && u.getToasterBackgroundColor(props);
}, function (props) {
  return props.type && u.getToasterTextColor(props);
}, function (props) {
  return props.type && u.getToasterTextColor(props);
});
var CloseButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background: none;\n    border: 0;\n    cursor: pointer;\n    height: 24px;\n    padding: 0;\n"])));
var ToasterGroup = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    pointer-events: none;\n    align-items: center;\n    justify-content: flex-end;\n    top: 0;\n    display: flex;\n    flex-direction: column;\n    height: 600px;\n    left: 0;\n    padding: 0 16px;\n    position: fixed;\n    right: 0;\n    z-index: 999999;\n\n    button {\n        pointer-events: auto;\n    }\n"])));
var TextWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
export default {
  CloseButton: CloseButton,
  StyledToastWrapper: StyledToastWrapper,
  ToasterGroup: ToasterGroup,
  TextWrapper: TextWrapper
};